import firebase from "firebase";
import { setLastSeenAt } from "../actions/notificationActions";
import { FIREBASE_NOTIFCATIONS_DB_URL } from "../util/constants";
export const notificationDatabase = firebase.database(
  firebase.initializeApp({ databaseURL: FIREBASE_NOTIFCATIONS_DB_URL }, "notificationDB")
);

export const watchNewNotifications = ({ dispatch, userId }) =>
  notificationDatabase
    .ref(`/notifications/${userId}/notifications`)
    .orderByChild("lastUpdatedAt")
    .limitToFirst(7)
    .on("value", dataSnapshot => {
      const notifications = {};
      dataSnapshot.forEach(function(childSnapshot) {
        notifications[childSnapshot.key] = childSnapshot.val();
      });

      if (notifications) {
        dispatch({ type: "NOTIFICATIONS_RECIEVED", notifications });
      }
    });
export const setLastSeenAtInFB = (userId, date) =>
  notificationDatabase.ref(`/notifications/${userId}/lastSeenAt`).set(date);

export const watchLastSeenAtDateChanges = ({ dispatch, userId }) =>
  notificationDatabase
    .ref(`/notifications/${userId}/lastSeenAt`)
    .on(
      "value",
      dateSnapShot => (dateSnapShot.val() ? dispatch(setLastSeenAt(dateSnapShot.val())) : dispatch(setLastSeenAt(0)))
    );

export const checkIsNewUser = userId =>
  firebase
    .database()
    .ref(`/singedupUserIds/${userId}`)
    .once("value")
    .then(resp => resp.toJSON() !== null);

export const addNewUser = userId =>
  firebase
    .database()
    .ref(`/singedupUserIds/${userId}`)
    .set(1);

const updateAdInteractionsUser = ({ user: { uid, name }, ad: { id, placement } }, key) =>
  new Promise((resolve, reject) => {
    let isUniqueRecord = true;

    return notificationDatabase
      .ref(`/ads/${id}/placements/${placement}/${key}/${uid}`)
      .transaction(user => {
        if (user) {
          isUniqueRecord = false;
          return { uid, name, views: user.views + 1 };
        }
        return { uid, name, views: 1 };
      })
      .then(() => resolve(isUniqueRecord));
  });
const updateAdInfo = ad => notificationDatabase.ref(`/ads/${ad.id}/data`).set(ad);

const incrementAdKey = ({ id, placement }, key) =>
  notificationDatabase.ref(`/ads/${id}/placements/${placement}/${key}`).transaction(views => views + 1);

export const trackAdViews = ({ ad, user }) =>
  incrementAdKey(ad, "views")
    .then(() => updateAdInfo(ad))
    .then(() => updateAdInteractionsUser({ ad, user }, "viewers"))
    .then(isUnique => isUnique && incrementAdKey(ad, "uniqueViews"));

export const trackAdClicks = ({ ad, user }) =>
  incrementAdKey(ad, "clicks")
    .then(() => updateAdInfo(ad))
    .then(() => updateAdInteractionsUser({ ad, user }, "clickers"))
    .then(isUnique => isUnique && incrementAdKey(ad, "uniqueClicks"));



// WEBPACK FOOTER //
// ./src/services/firebaseRealtimeDb.js